import { Component, Inject, OnInit } from '@angular/core';
import { EmailService } from '../../email/email.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatSnackBar, MatTableDataSource } from '@angular/material';
import { Router } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { SelectionModel } from '@angular/cdk/collections';

@Component({
  selector: 'app-mapemail',
  templateUrl: './mapemail.component.html',
  styleUrls: ['./mapemail.component.css']
})
export class MapemailComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) private Fdata: any,protected data:EmailService,private dialog: MatDialog, protected router: Router, protected fb: FormBuilder, protected msg: MatSnackBar,private dialogRef: MatDialogRef<MapemailComponent>) { }
  displayedColumns = ['S.No.','Name', 'Email','Action'];
  public dataSource = new MatTableDataSource<any>();
  selection = new SelectionModel<Element>(true, []);
  selectedAction = 0;
  public page = 1;
  collectionSize: any;
  pageSize = 10;
  rows: any;
  // rows:any[]=[];
  EMLrecords:any=[];
  groupid:number=0;
  cdata:any[]=[];

  ngOnInit() {
    console.log("gettng data ::",this.Fdata);
    let where=this.Fdata.groupid;
    this.groupid=this.Fdata.groupid;
    this.data.getlistemail(where).subscribe((res:any)=>{
      if(res!=''){
        console.log("getting result here :::",res);
        this.collectionSize = res.records.length
        this.rows=res.records
        this.EMLrecords=res.records
        .map((EMLrecords, i) => ({ id: i + 1, ...EMLrecords }))
        .slice(
          (this.page - 1) * this.pageSize,
          (this.page - 1) * this.pageSize + this.pageSize
        );
      }
      console.log("getting res",res);
    })
    
  }
  close() {
    console.log("on closing ",this.EMLrecords);
    
    this.dialogRef.close({data:this.Fdata, singleass:1});
  }
  save(){
    // if(this.dataSource.data){

    // }
    console.log("dfghjkl",this.selection.selected);
    if(this.selection.selected.length>0)
      this.dialogRef.close({data:this.selection.selected,groupid:this.groupid,singleass:0})
    else
      this.openSnackBar('please select at least any one email','clear')
    
    // this.dialogRef.close({data:this.selection.selected,groupid:this.groupid,singleass:0});
  }
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows =  this.EMLrecords.length;
    return numSelected === numRows;
  }
  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
        this.selection.clear() :
        this.EMLrecords.forEach((row:any,index:number) =>{
          this.selection.select(row)
        })
  }
  addDisposingle(id:any){
    let selct=[{id:id}]
     selct=   selct.filter(obj1 => !this.EMLrecords.some(obj2 => obj1.id === obj2.id))
    this.dialogRef.close({array:selct,type:2})
  }

  masterEvent(ev:any){
    console.log("event.target.value",ev.target.value);
    if(this.selection.selected.length>0 && ev.target.value==1){
      this.masterToggle()
    }else if(ev.target.value==2){
      this.masterToggle()
    }else{

    }
    

  }

  singleAssign(element:any){
    this.data.saveEmailSetting({fdata:[element],groupid:this.groupid}).subscribe((res:any)=>{
      if(res){
        console.log("getting all records ::",res);
        this.openSnackBar("SMTP Email added Successfully",'clear');
        let groupid=this.groupid
        this.data.getlistemail(groupid).subscribe((res:any)=>{
          console.log("getting data after assign :",res);
          if(res!=''){
            this.EMLrecords=res.records;
            this.collectionSize = res.records.length
            this.rows=res.records
            this.EMLrecords.data=res.records
            .map((EMLrecords, i) => ({ id: i + 1, ...EMLrecords }))
            .slice(
              (this.page - 1) * this.pageSize,
              (this.page - 1) * this.pageSize + this.pageSize
            );
        }
       })
      }
    })
  }
  openSnackBar(message: string, action: string) {
    this.msg.open(message, action, {
      duration: 3000
      , verticalPosition: 'top',
      horizontalPosition: 'center',
      panelClass: ['snackbarwarn']
    });
  }

  // refreshTable() {
  //   this.EMLrecords.data = this.rows
  //     .map((EMLrecords, i) => ({ id: i + 1, ...EMLrecords }))
  //     .slice(
  //       (this.page - 1) * this.pageSize,
  //       (this.page - 1) * this.pageSize + this.pageSize
  //     );
  //     this.selection.clear()
  // }
  refreshTable() {
    this.EMLrecords = this.rows
      .map((EMLrecords, i) => ({ id: i + 1, ...EMLrecords }))
      .slice(
        (this.page - 1) * this.pageSize,
        (this.page - 1) * this.pageSize + this.pageSize
      );

      this.selection.clear()
  }

  OnchangeOption(event:any){
    console.log("getting event value",event.target.value);
      if(event.target.value==1){
        this.selection.clear()
      }else{
        this.masterToggle()
      }
    }

    // OnchangeOption(event:any){
    //   console.log("getting event value",event.target.value);
    //     if(event.target.value==1){
    //       this.isAllCheckBoxChecked()
    //     }else{
    //       this.isAllCheckBoxChecked()
    //     }
    //   }



    // checkAllCheckBox(ev: any) {
    //   this.dataSource.data.forEach(x => x.checked = ev.target.checked)
    //   console.log("getting all checked data",this.dataSource.data);
      
    // }
    
    // isAllCheckBoxChecked() {
    //   return this.dataSource.data.every(p => p.checked);
    // }

}
